import { getUserMenuByModuleId } from '@/api/user.js';
export default {
  data(){
    return {
      pageParams: {
        page: 1,
        limit: 10,
        total: 0
      },
    }
  },
  methods: {
    onBtnClick(eventName,row){
      this[eventName](row);
    },
    handleSizeChange(val) {
      this.pageParams.page = 1;
      this.pageParams.limit = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.getData();
    },
    toFilter(){
      this.pageParams.page = 1;
      this.getData();
    }
  }
}